<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" toggleButtonSize="small" @keyup.enter="loadAgentOutboundDetailsReports(1, null, true)">
      <template slot="actions">
        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-download" size="small" @click="exportData">{{ $t('export') }}</vs-button>
      </template>

      <div class="vx-row" id="outbound-detail-filter-container">
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <date-picker v-model="searchParams.from" :model="searchParams.from" :placeholder="$t('date_filter_from')" class="mb-3"></date-picker>
<!--          <v-select :options="counselorsOptions" :reduce="label => label.value" :placeholder="$t('outgoing_counselor')" v-model="searchParams.outgoing_conselor" class="w-full mb-3" />-->
          <select v-model="searchParams.outgoing_conselor" class="vs-inputx vs-input--input normal w-full mb-3" style="width:100%;" >
            <option value="">{{ $t('outgoing_counselor') }}</option>
            <option v-for="(option, key) in counselorsOptions" :key="'ivr_staff_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <date-picker v-model="searchParams.to" :model="searchParams.to" :placeholder="$t('date_filter_to')" class="mb-3"></date-picker>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <vs-input :placeholder="$t('called_number')" v-model="searchParams.dst" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
<!--          <v-select :options="translatedDispositionOptions" :reduce="label => label.value" :placeholder="$t('disposition')" v-model="searchParams.disposition" class="w-full mb-3" />-->
          <select v-model="searchParams.disposition" class="vs-inputx vs-input--input normal w-full mb-3" style="width:100%;" >
            <option value="">{{ $t('disposition') }}</option>
            <option v-for="(option, key) in translatedDispositionOptions" :key="'ivr_staff_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadAgentOutboundDetailsReports(1, null, true)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="outboundDetailsDataContainer" :title="$t('outbound_details')" class="mb-8 vs-con-loading__container">
      <template slot="actions">
        <shared-call-statistics-tab-nav></shared-call-statistics-tab-nav>
      </template>

      <shared-outbound-details-list
        :cdrDatas="cdrDatas"
        :activeColumns="activeColumns"
      ></shared-outbound-details-list>

      <template slot="footer">
        <paginate
          :total="cdrPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadAgentOutboundDetailsReports"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>
    </vx-card>
  </div>
</template>

<script>
import Paginate from '@/components/Paginate'
import SharedCallStatisticsTabNav from '@/views/Shared/CallStatistics/TabNav'
import DatePicker from '@/components/form-inputs/DatePicker'
import AgentOutboundDetailsReport from '@/models/AgentOutboundDetailsReport'
import Pagination from '@/mixins/paginate'
import SharedOutboundDetailsList from '@/views/Shared/OutboundDetails/List'
import SharedInboundDetailsList from '@/views/Shared/InboundDetails/List.vue'

export default {
  name: 'User.CallStatistics.OutboundDetails',
  mixins: [Pagination],
  components: {
    SharedInboundDetailsList,
    SharedCallStatisticsTabNav,
    DatePicker,
    Paginate,
    SharedOutboundDetailsList
  },
  data () {
    return {
      activeColumns: {},
      cdrDatas: {},
      cdrPages: 1,
      initialPage: typeof this.$route.query.page !== 'undefined' && this.$route.query.page > 0 ? parseInt(this.$route.query.page) : 1,
      cdrListCount: 0,
      counselorsOptions: [],
      dispositionOptions: [
        {
          label: 'ANSWERED',
          value: 'ANSWERED'
        },
        {
          label: 'NO ANSWER',
          value: 'NO ANSWER'
        },
        {
          label: 'BUSY',
          value: 'BUSY'
        }
      ],
      itemPerPage: null,
      searchParams: {
        from: typeof this.$route.query.from !== 'undefined' ? this.$route.query.from : this.$momentHelper.getCurrentDate(),
        to: typeof this.$route.query.to !== 'undefined' ? this.$route.query.to : this.$momentHelper.getCurrentDate(),
        service_name: typeof this.$route.query.service_name !== 'undefined' ? this.$route.query.service_name : '',
        dst: typeof this.$route.query.dst !== 'undefined' ? this.$route.query.dst : '',
        disposition: typeof this.$route.query.disposition !== 'undefined' ? this.$route.query.disposition : '',
        outgoing_conselor: typeof this.$route.query.outgoing_conselor !== 'undefined' ? this.$route.query.outgoing_conselor : ''
      },
      companyId: this.$store.getters.userInfo.company.id
    }
  },
  computed: {
    translatedDispositionOptions () {
      return this.dispositionOptions.map(option => ({
        label: this.$t(option.label),
        value: option.value
      }))
    }
  },
  mounted () {
    this.loadAgentOutboundDetailsReports(this.initialPage, null)
  },
  methods: {
    async loadAgentOutboundDetailsReports (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#outboundDetailsDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      this.$router.replace({ query: { ...this.searchParams, page, itemPerPage } })
      const response = await AgentOutboundDetailsReport.findAll({ ...this.searchParams, page, itemPerPage })
      this.cdrDatas = response.data.data.outboundDetails
      this.cdrPages = response.data.meta.pagination.last_page
      this.counselorsOptions = response.data.meta.options.extensions
      this.activeColumns = response.data.meta.activeColumns
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#outboundDetailsDataContainer > .con-vs-loading')
    },
    async exportData () {
      this.$store.dispatch('setIsMainTableLoading', true)
      const language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
      await AgentOutboundDetailsReport.export({ ...this.searchParams, companyId: this.companyId, language, export: true }) // TODO: Process const response =
      this.$store.dispatch('setIsMainTableLoading', false)
    }
  }
}
</script>

<style scoped>

</style>
